import { Database, FileClock, Info } from "lucide-react";
import { useEffect, useState } from "react";
import { APP_VERSION } from "../../app/version";
import {
  formatBytes,
  getStorageSummary,
  type StorageSummary,
} from "../../storage/storageAdmin";
import { QrSessionsPanel } from "../transfer";

export function ActivityPage() {
  const [summary, setSummary] = useState<StorageSummary | null>(null);

  useEffect(() => {
    void getStorageSummary().then(setSummary);
  }, []);

  return (
    <div className="activity-layout">
      <section className="metric-grid">
        <article className="metric-card">
          <Database aria-hidden="true" />
          <span>Local storage used</span>
          <strong>{summary ? formatBytes(summary.usage) : "Checking..."}</strong>
          <small>
            {summary?.quota
              ? `${formatBytes(summary.quota)} browser estimate`
              : "Browser estimate unavailable"}
          </small>
        </article>
        <article className="metric-card">
          <FileClock aria-hidden="true" />
          <span>Persistence</span>
          <strong>{summary?.persisted ? "Requested" : "Best effort"}</strong>
          <small>Browsers may still clear site data.</small>
        </article>
        <article className="metric-card">
          <Info aria-hidden="true" />
          <span>App version</span>
          <strong>v{APP_VERSION}</strong>
          <small>QR protocol v1 · Link format v1</small>
        </article>
      </section>

      <QrSessionsPanel />
    </div>
  );
}
